import React, { useState } from 'react';

export interface HelperTextContentType {
  id: string;
  content: React.ReactNode;
  open: boolean;
  offsetY?: number;
}
interface HelperTextContextType {
  currentHelpers: Array<HelperTextContentType>;
  setCurrentHelpers: React.Dispatch<React.SetStateAction<Array<HelperTextContentType>>>;
}

export const HelperTextContext = React.createContext<HelperTextContextType | undefined>(undefined);

interface HelperTextProviderProps {
  children: React.ReactNode;
}

const HelperTextProvider: React.FC<HelperTextProviderProps> = ({ children }) => {
  const [currentHelpers, setCurrentHelpers] = useState<Array<HelperTextContentType>>([]);

  const value = {
    currentHelpers,
    setCurrentHelpers,
  };

  return <HelperTextContext.Provider value={value}>{children}</HelperTextContext.Provider>;
};

export default HelperTextProvider;
